
import { Component, Mixins } from "vue-property-decorator";
import { IHospitalizedHisInformationItemSelectBehavior } from "../../../../../../documaker/domain/format/objects";
import {
  IHospitalizedHisInformationItemSelectBehaviorPropertyEditable,
  instanceOfIHospitalizedHisInformationItemSelectBehaviorPropertyEditable
} from "../../../../../domain/editableFormat/properties";

@Component
export default class HospitalizedHisInformationItemSelectBehaviorPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IHospitalizedHisInformationItemSelectBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IHospitalizedHisInformationItemSelectBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isHospitalizedHisInformationItemDefaultSelectBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(
      s => instanceOfIHospitalizedHisInformationItemSelectBehaviorPropertyEditable(s) && s.hospitalizedHisInformationItemSelectBehavior().isEditable(),
      false
    );
  }

  get hospitalizedHisInformationItemSelectBehavior(): IHospitalizedHisInformationItemSelectBehavior {
    return this.readPropertyOrDefault(
      s => s.hospitalizedHisInformationItemSelectBehavior().getValue(),
      {
        shouldSelectHospitalizedOnly: false,
        baseDateReferBehavior: {
          isEnable: false,
          reference: null,
        },
      });
  }

  set hospitalizedHisInformationItemSelectBehavior(value: IHospitalizedHisInformationItemSelectBehavior) {
    this.writePropertyWhenValid(s => s.hospitalizedHisInformationItemSelectBehavior().setValue(value));
  }
}
